import { render } from "./ContentHero.vue?vue&type=template&id=dca6c8c6"
import script from "./ContentHero.vue?vue&type=script&lang=js"
export * from "./ContentHero.vue?vue&type=script&lang=js"

import "./ContentHero.vue?vue&type=style&index=0&id=dca6c8c6&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__